module.exports = __webpack_public_path__ + "img/round2-variation2.cf273a93.gif";